<script lang="ts">
  import TerminateQitMailDetail from './TerminateQitMailDetail.svelte';
  import TerminateSpaaqsMailDetail from './TerminateSpaaqsMailDetail.svelte';
  import TerminateSpaaqsSequrityOptionDetail from './TerminateSpaaqsSequrityOptionDetail.svelte';

  import { push } from 'svelte-spa-router';
  import Loading from '../../../../etc/loader.svelte';
  import { loginUser } from '../../../../components/auth/LoginUser';
  import RepositoryFactory, { BUNDLE_OPTION_HIKARI01_INHERITED } from '../../../../repositories/RepositoryFactory';
  import type { BundleOptionHikari01InheritedResult as FetchResult } from '../../../../repositories/bundleoptionhikari01inherited';

  let pageStatus: 'TOP' | 'TERMINATE_QIT_MAIL' | 'TERMINATE_SPAAQS_MAIL' | 'TERMINATE_SEQURITY_OPTION' = 'TOP';

  let fetchResultList: FetchResult[];
  let targetFetchResult: FetchResult;

  /**
   * 一覧取得
   */
  let promise = (async () => {
    const repository = RepositoryFactory[BUNDLE_OPTION_HIKARI01_INHERITED];
    await repository
      .fetchList()
      .then((res) => {
        fetchResultList = res;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          push('/login');
        } else {
          alert('エラーが発生しました。');
        }
      });
    return fetchResultList;
  })();

  /**
   * 画面表示制御
   */
  const isAvaiableDetailButton = (target: FetchResult): boolean => {
    return target.contractStatusCode === 'RUNNING';
  };

  const isAvaiableMailAddress = (target: FetchResult): boolean => {
    return ['QIT_MAIL', 'SPAAQS_JASPER_MAIL_SERVICE'].includes(target.hikari01InheritedOptionCode);
  };

  /**
   * 画面遷移系
   */
  const handleTransitionTerminateQitMail = (): void => {
    pageStatus = 'TERMINATE_QIT_MAIL';
  };

  const handleTransitionTerminateSpaaqsMail = (): void => {
    pageStatus = 'TERMINATE_SPAAQS_MAIL';
  };

  const handleTransitionTerminateSequrityOption = (): void => {
    pageStatus = 'TERMINATE_SEQURITY_OPTION';
  };

  const handleTransition = (target: FetchResult): void => {
    targetFetchResult = target;

    if ('QIT_MAIL' === target.hikari01InheritedOptionCode) {
      handleTransitionTerminateQitMail();
      return;
    }

    if ('SPAAQS_JASPER_MAIL_SERVICE' === target.hikari01InheritedOptionCode) {
      handleTransitionTerminateSpaaqsMail();
      return;
    }
    if (
      ['SPAAQS_SECURITY_BASIC', 'SPAAQS_SECURITY_ONLINE', 'SPAAQS_SECURITY_360', 'SPAAQS_KIDS_FILTER'].includes(
        target.hikari01InheritedOptionCode
      )
    ) {
      handleTransitionTerminateSequrityOption();
      return;
    }
  };
</script>

{#await promise}
  <Loading />
{:then fetchResultList}
  {#if pageStatus === 'TOP'}<!-- トップ画面 -->
    <div class="h-auto p-6 bg-white m-auto max-w-4xl">
      <div class="mb-6">
        <div class="container flex justify-between">
          <h2 class="text-xl font-bold text-gray-700">その他オプション</h2>
        </div>
      </div>

      <div class="shadow rounded bg-white border-t-2 border-green-400">
        <div class="flex-1 m-10">
          <div class="mb:font-sm w-full">
            <p>下記は、事業継承前から契約いただいているオプションとなります。</p>
            <p>各オプションの詳細確認、解約の場合は、オプション横の詳細ボタンから確認ください</p>
          </div>
        </div>
        <div class="flex-1 my-10 mx-5">
          <div class="mt-10">
            <div class="flex flex-col divide-y divide-gray-300">
              <!-- [Note] divideの線をだすためにからのdivタグを入れています -->
              <div class="inline-grid grid-cols-6 justify-items-center items-center py-4">
                <div class="grid-1 col-span-2 justify-self-start">
                  <p class="label-title">オプション</p>
                </div>
                <div class="grid-1 col-span-1 justify-self-center">
                  <p class="label-title">税込金額</p>
                </div>
                <div class="grid-1 col-span-1 justify-self-center">
                  <p class="label-title">契約開始日</p>
                </div>
                <div class="grid-1 col-span-1 justify-self-center">
                  <p class="label-title">契約終了日</p>
                </div>
                <div class="grid-1" />
              </div>
              <div />
              {#each fetchResultList as fetchResult}
                <div class="inline-grid grid-cols-6 justify-items-center items-center py-4">
                  <div class="grid-1 col-span-2 justify-self-start">
                    <p class="label-value">
                      {fetchResult.hikari01InheritedOptionName}
                    </p>
                    {#if isAvaiableMailAddress(fetchResult)}
                      <p class="label-value">
                        {fetchResult.inheritedMailAddress ?? ''}
                      </p>
                    {/if}
                  </div>
                  <div class="grid-1 col-span-1 justify-self-center">
                    <p class="label-value">
                      {`${fetchResult.inheritedOptionAmount}円`}
                    </p>
                  </div>
                  <div class="grid-1 col-span-1 justify-self-center">
                    <p class="label-value">{fetchResult.contractStartDate}</p>
                  </div>
                  <div class="grid-1 col-span-1 justify-self-center">
                    <p class="label-value">
                      {fetchResult.contractEndDate ?? '-'}
                    </p>
                  </div>
                  {#if isAvaiableDetailButton(fetchResult)}
                    <div class="grid-1 col-span-1 justify-self-center">
                      <div class="grid-1 justify-self-end">
                        <button on:click={() => handleTransition(fetchResult)} class="button-primary"> 詳細 </button>
                      </div>
                    </div>
                  {/if}
                </div>
                <div />
              {/each}
            </div>
          </div>
        </div>
      </div>
    </div>
  {:else if pageStatus === 'TERMINATE_QIT_MAIL'}<!-- 旧qit mail 解約 -->
    <TerminateQitMailDetail props={targetFetchResult} />
  {:else if pageStatus === 'TERMINATE_SPAAQS_MAIL'}<!-- 旧spaaqs mail 解約 -->
    <TerminateSpaaqsMailDetail props={targetFetchResult} />
  {:else if pageStatus === 'TERMINATE_SEQURITY_OPTION'}<!-- 旧spaaqs セキュリティオプション 解約 -->
    <TerminateSpaaqsSequrityOptionDetail props={targetFetchResult} />
  {/if}
{/await}

<style lang="postcss">
  p:not([class]) {
    @apply tracking-normal mb-1;
  }
  .label-title {
    @apply text-sm font-medium text-gray-700;
  }
  .label-value {
    @apply text-sm font-medium text-gray-900;
  }
  .button-primary {
    @apply bg-green-400 rounded hover:bg-green-500 text-sm font-semibold text-white focus:outline-none px-6 py-2;
  }
  .button-primary:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
